import React, { FunctionComponent } from 'react';

import styled from 'styled-components';

import { MotorGroupStepType } from 'scenes/motor/types';

import { ProgressFlowBarWrapper } from 'scenes/common/components/Header/HeaderTop';
import FlowDescription from './FlowDescription';
import NumberedProgressBarItem from './NumberedProgressBarItem';

const ProgressWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

const StepWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

const LAST_PREQUOTE_INDEX = 4;
const FIRST_POSTQUOTE_INDEX = 5;
const LAST_POSTQUOTE_INDEX = 7;
const OFFSET_POSTQUOTE_INDEX = 5;

const renderStep = (
  progress: number,
  currentProgressBarFlow: MotorGroupStepType
) => {
  const motorGroupStepArray = Object.values(MotorGroupStepType);
  const preQuoteGroupStep = motorGroupStepArray.slice(0, 5);
  const postQuoteGroupStep = motorGroupStepArray.slice(5);
  const currentFlowIndex = motorGroupStepArray.findIndex(
    (item) => item === currentProgressBarFlow
  );

  if (currentFlowIndex > LAST_PREQUOTE_INDEX) {
    return postQuoteGroupStep.map((flow: MotorGroupStepType, i: number) => {
      const currentIndex = i + OFFSET_POSTQUOTE_INDEX;
      return (
        <NumberedProgressBarItem
          key={flow}
          flowNumber={currentIndex + 1}
          flowName={flow}
          isCurrentFlow={currentProgressBarFlow === flow}
          isFlowComplete={currentIndex < currentFlowIndex}
          isFirstPostquoteStep={currentIndex === FIRST_POSTQUOTE_INDEX}
          isLastPostQuoteStep={currentIndex === LAST_POSTQUOTE_INDEX}
          progress={progress}
        />
      );
    });
  }

  return preQuoteGroupStep.map((flow: MotorGroupStepType, i: number) => (
    <NumberedProgressBarItem
      key={flow}
      flowNumber={i + 1}
      flowName={flow}
      isCurrentFlow={currentProgressBarFlow === flow}
      isFlowComplete={i < currentFlowIndex}
      isLastPrequoteStep={i === LAST_PREQUOTE_INDEX}
      progress={progress}
    />
  ));
};

export const NumberedProgressBar: FunctionComponent<{
  flowProgress: {
    progress: number;
    currentProgressBarFlow: MotorGroupStepType;
    stepNumber: number;
  };
}> = ({ flowProgress: { progress, currentProgressBarFlow, stepNumber } }) => (
  <ProgressFlowBarWrapper>
    <ProgressWrapper>
      <StepWrapper>{renderStep(progress, currentProgressBarFlow)}</StepWrapper>
      <FlowDescription
        stepNumber={stepNumber}
        flowName={currentProgressBarFlow}
      />
    </ProgressWrapper>
  </ProgressFlowBarWrapper>
);

export default NumberedProgressBar;
